export default "__VITE_ASSET__BGa4bkyq__"